import styles from '../style.module.less'
export default {
    props: {
        title: {
            type: String
        },
        value: {
            type: [String, Number]
        }
    },
    render() {
        return <div class={styles['detail-c']}>
            <p class={styles['detail-c-t']}>{this.title}</p>
            {/* detail-c-v */}
            <p class={styles['detail-c-v']}>{this.value}</p>
        </div>
    }
}